export default function makeReOrderBtn({ btn, events, action }) {
    let initialized = false;
    return Object.freeze({
        init,
    });
    function init() {
        if (initialized)
            return;
        btn.classList.remove('no-display');
        _addListeners();
        initialized = true;
    }
    function _addListeners() {
        btn.addEventListener('click', (e) => {
            events.emit(action);
        });
    }
}
